import type { ThemeWithoutTokens } from '../theme.types';

export const highlightedIconTokens = (theme: ThemeWithoutTokens) =>
  ({
    highlightedIconContainerPadding: theme.space.component.x.s,
    highlightedIconPadding: theme.space.component.x.xs,
    highlightedIconRadius: theme.radiuses.xl,

    // colors
    highlightedIconBlueTextColor: theme.colors.primary.textRegular,
    highlightedIconBlueBackgroundColor: theme.palette.blue400Alpha,

    highlightedIconGreenTextColor: theme.colors.success.textRegular,
    highlightedIconGreenBackgroundColor: theme.palette.green400alpha,

    highlightedIconOrangeTextColor: theme.colors.warning.textRegular,
    highlightedIconOrangeBackgroundColor: theme.palette.orange400alpha,

    highlightedIconPurpleTextColor: theme.palette.purple400,
    highlightedIconPurpleBackgroundColor: theme.palette.purple400alpha,

    highlightedIconYellowTextColor: theme.palette.yellow400,
    highlightedIconYellowBackgroundColor: theme.palette.yellow400alpha,

    highlightedIconRedTextColor: theme.colors.danger.textRegular,
    highlightedIconRedBackgroundColor: theme.palette.red400alpha,

    highlightedIconGreyTextColor: theme.palette.grey400,
    highlightedIconGreyBackgroundColor: theme.palette.grey50,
  }) as const;
